export const ON_SAVE_DATA = "ON_SAVE_DATA";
export const ON_SEND_DATA_REQUEST = "ON_SEND_DATA_REQUEST";
export const ON_SEND_DATA_SUCCEED = "ON_SEND_DATA_SUCCEED";
export const ON_SEND_DATA_FAILED = "ON_SEND_DATA_FAILED";
export const ON_SAVE_EMAIL = "ON_SAVE_EMAIL";
